import {Home, Testimonials} from '../../components/splide'

const init = () => {
  Home()
  Testimonials()
}

export default init
